import { useCallback, useEffect } from "react";

import StopIcon from "@mui/icons-material/Stop";

import { useAppDispatch, useAppSelector } from "app/hooks";

import WidgetButton from "../components/widget-button.component";
import { RECORDING_STATE_IN_PROGRESS } from "../medical-scribe-constants";
import {
  selectMedicalScribeRecordingState,
  setOpenConfirmationDialog
} from "../medical-scribe.slice";

export default function StopRecordingButton() {
  const dispatch = useAppDispatch();
  const recordingState = useAppSelector(selectMedicalScribeRecordingState);
  const handleClickStop = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      event.preventDefault();
      dispatch(setOpenConfirmationDialog(true));
    },
    [dispatch]
  );

  const shouldShowAwayPrompt = recordingState === RECORDING_STATE_IN_PROGRESS;

  useEffect(() => {
    if (!shouldShowAwayPrompt) return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = "";
      return "";
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [shouldShowAwayPrompt]);

  return (
    <WidgetButton
      tooltip="Stop Audio Recording"
      startIcon={<StopIcon />}
      onClick={handleClickStop}
    />
  );
}
